/**
 * The platform switch over a Social profiles panel (DD-007, DD-043). The host
 * owns the active platform so its Edit action knows which one to open.
 */

import React from "react";
import { SocialPlatform } from "@/types";
import { PanelFilterTabs } from "@/components/ui/PanelFilterTabs";
import { PLATFORM_LABELS, SOCIAL_PLATFORMS } from "../socialProfiles";

const TAB_OPTIONS = SOCIAL_PLATFORMS.map((p) => ({ id: p, label: PLATFORM_LABELS[p] }));

export const SocialPlatformTabs: React.FC<{
  platform: SocialPlatform;
  onChange: (platform: SocialPlatform) => void;
}> = ({ platform, onChange }) => {
  const handleChange = (id: string) => {
    const next = SOCIAL_PLATFORMS.find((p) => p === id);
    if (next) onChange(next);
  };

  return <PanelFilterTabs options={TAB_OPTIONS} activeId={platform} onChange={handleChange} />;
};
